'use client';

import type { Page, WhatWeDoPage } from '../../lib/types';
import { usePathname } from 'next/navigation';
import PageBodyBackground from '../ui/PageBodyBackground';
import HeroWhatWeDo from '../ui/HeroWhatWeDo';
import React from 'react';
import './WhatWeDoLayout.css';
import Cookies from '../sections/Cookies';
import { trackEvent } from '@/lib/analytics';
import WhatWeDoSection from '../sections/WhatWeDoSection';
import CaseStudiesImageGallery from '../sections/CaseStudiesImageGallery';
import LayoutTitleText_1_2 from '../sections/LayoutTitleText_1_2';
import BannerContact from '../sections/BannerContact';
import ScrollForMoreOverlay from '../ui/ScrollForMoreOverlay';
import WhatWeDoCarousel from '../sections/WhatWeDoCarousel';

type WhatWeDoLayoutProps = {
  page: Page;
};

export default function WhatWeDoLayout({ page }: WhatWeDoLayoutProps) {
  const _whatWeDoPage = page as WhatWeDoPage;
  const pathname = usePathname();


  return (
    <>
      
      <PageBodyBackground heroId="hero-what-we-do" />
      
      {/* Hero Section */}
      <HeroWhatWeDo id="hero-what-we-do" />
      <ScrollForMoreOverlay />

      {/* What We Do */}
      <WhatWeDoSection />

      <div className="h-[1.25rem] lg:h-[2.6875rem]"></div>

      {/* Case Studies Gallery */}
      {/* <CaseStudiesImageGallery /> */}

      {/* Join our team */}
      <WhatWeDoCarousel />

      <div className="h-[3.875rem] lg:h-[6.875rem]"></div>

      <LayoutTitleText_1_2
        eyebrow="From promise to proof"
        heading={<>How do you<br/>measure&nbsp;up?</>}
        bodyText={
          <>
            <p className="body-lg mb-6">
              ​​Today, most customer experiences fall short. In an always-on world, people judge brands not by what they say but by what they deliver. 
              The gap between brand promise and lived reality is now the battleground; 93% of brands fail to meet expectations according to our X Index.
            </p>
            <p className="body-lg">
              ​At Havas CX, we  connect design to technology, strategy to operations, and human understanding to real results – moving our clients from promise to proof. 
            </p>
          </>
        }
        ctaText="Explore the X Index"
        ctaHref="https://www.havasxindex.com/"
        ctaOnClick={() => {
          trackEvent('what_we_do_click', {
            click_text: 'Explore the X Index',
            click_url: 'https://www.havasxindex.com/',
            page_path: pathname
          });
        }}
        pathname={pathname}
      />

      <div className="h-[3.6875rem] lg:h-[9.9375rem]"></div>

      <BannerContact
        heading="Let’s talk about how we can "
        underlinedWord="partner."
        underlinePath="M1.25006 5.04193C2.85359 4.66223 4.45711 4.28253 37.0941 3.51647C69.7311 2.7504 133.353 1.60947 167.294 1.25002C203.568 1.34718 208.115 2.72266 210.08 3.28791"
        eyebrow="Get in touch"
        email="hello@havascx-us.com"
        emailHref="mailto:hello@havascx-us.com"
        pathname={pathname}
      />

      <div className="h-[3.6875rem] lg:h-[9.9375rem]"></div>
      
      {/* Cookies */}
      <Cookies />
    
    </>
  );
}
